import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  AmcAdminAccess,
  getAmcAdminAccess,
  getAmcAdminList,
  updateAmcAdmin,
} from '../../redux-store/actions/userManagement';
import { AddAmcAdminRequestBody, AmcAdmin } from '../../redux-store/types/api-types';
import { ColumnType } from '../DataTable';
import { useHistory } from 'react-router';
import UserMgmtListPage, {
  NameLinkCell,
  buildAccessColumn,
  buildActionsColumn,
  formatPhone,
  formatUserName,
  matchesUserSearch,
} from './UserMgmtListPage';

function amcAdmin(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [accessForEditAdd, setAccessForEditAdd] = useState(false);

  return (
    <UserMgmtListPage<AmcAdmin>
      loadData={async () => {
        const res = (await dispatch(getAmcAdminList())) as unknown as AmcAdmin[];
        const access = (await dispatch(getAmcAdminAccess())) as unknown as AmcAdminAccess;
        setAccessForEditAdd(access.amcAdminAccess);
        return res || [];
      }}
      searchPlaceholder="Search for AMC Admins"
      inviteLabel="Add AMC Admin"
      showInvite={accessForEditAdd}
      onInvite={() => history.push('add-amc-admin')}
      accessDisabled={!accessForEditAdd}
      filterRow={(row, q) =>
        matchesUserSearch(q, [
          formatUserName(row.user),
          row.user?.email,
          `${row.user?.countryCode || ''}${row.user?.phone || ''}`,
        ])
      }
      getColumns={({ onToggleAccess, accessDisabled }) => {
        const columns: ColumnType[] = [
          {
            header: 'Name',
            align: 'left',
            headerAlign: 'left',
            renderCell: (row: AmcAdmin) => (
              <NameLinkCell
                label={formatUserName(row.user)}
                to={{ pathname: 'amc-admin-details', state: { amcAdminId: row.id } }}
              />
            ),
          },
          {
            header: 'Email Id',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: AmcAdmin) => row.user.email || 'N/A',
          },
          {
            header: 'Mobile number',
            align: 'left',
            headerAlign: 'left',
            valueGetter: (row: AmcAdmin) => formatPhone(row.user),
          },
          buildAccessColumn(onToggleAccess, accessDisabled),
          buildActionsColumn((row: AmcAdmin) => [
            {
              label: 'View Details',
              icon: '/images/view-application.svg',
              to: { pathname: 'amc-admin-details', state: { amcAdminId: row.id } },
            },
            ...(accessForEditAdd
              ? [
                  {
                    label: 'Edit Details',
                    icon: '/images/edit.svg',
                    to: { pathname: 'edit-amc-admin', state: { amcAdminId: row.id } },
                  },
                ]
              : []),
          ]),
        ];
        return columns;
      }}
      onAccessChange={async (row, nextActive) =>
        (await dispatch(
          updateAmcAdmin(row.id as number, {
            ...(row as unknown as AddAmcAdminRequestBody),
            isActive: nextActive,
          })
        )) as unknown as AmcAdmin
      }
    />
  );
}

export default amcAdmin;
